import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesTasksByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesTasksByIdPatchAsyncSlice } from './patch';

export const coreInitiativesTasksByIdReducers = combineReducers({
	delete: coreInitiativesTasksByIdDeleteAsyncSlice.asyncReducers,
	patch: coreInitiativesTasksByIdPatchAsyncSlice.asyncReducers
});

export const coreInitiativesTasksByIdWatchers = combineAllWatchers([
	coreInitiativesTasksByIdDeleteAsyncSlice.asyncWatchers,
	coreInitiativesTasksByIdPatchAsyncSlice.asyncWatchers
]);
